import { compose, withHandlers } from 'recompose';

import MailchimpConnectionPage from './MailchimpConnectionPage';
import config from '../../../../../../config';
import withMailchimpSettings from '../withMailchimpSettings';
import withToggle from '../../../../../common/hoc/withToggle';
import { MAILCHIMP_REDIRECT_PATH } from '../constants';

export default compose(
  withMailchimpSettings,
  withToggle('opened', false),
  withHandlers({
    handleConnect: props => () => {
      props.openedOn();
      const redirectUri = `${window.location.origin}${MAILCHIMP_REDIRECT_PATH}`;

      const urlToOpen = `https://login.mailchimp.com/oauth2/authorize?response_type=code&client_id=${config.mailchimpClientId}&redirect_uri=${redirectUri}`;

      window.location.replace(urlToOpen);
    },
  })
)(MailchimpConnectionPage);
